import React from 'react'
import t from '../../translations/i18n'
import '../../scss/metodos-pago.scss'

export default function MetodosDePago() {
  const metodoPago = {
    tittle_method_1: t('meotodPago.tittle_method_1'),
    method_1: t('meotodPago.method_1'),
    status_method_1: t('meotodPago.status_method_1'),
    tittle_method_2: t('meotodPago.tittle_method_2'),
    method_2: t('meotodPago.method_2'),
    status_method_2: t('meotodPago.status_method_2'),
    tittle_method_3: t('meotodPago.tittle_method_3'),
    method_3: t('meotodPago.method_3'),
    status_method_3: false
  }

  return (
    <div className="page-content easybuy-payment-page">
      <div className="container">
        <div className="easybuy-payment-header text-center">
          <span className="easybuy-payment-badge">
            <i className="la la-credit-card"></i>
            Métodos de pago
          </span>

          <h2>{t('meotodPago.tittle')}</h2>

          <p>
            Elige el método de pago disponible que mejor se adapte a tu compra.
          </p>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="easybuy-payment-list">
              {metodoPago.status_method_1 && (
                <div className="easybuy-payment-item">
                  <div className="easybuy-payment-icon">
                    <i className="la la-credit-card"></i>
                  </div>

                  <div className="easybuy-payment-content">
                    <h3>{metodoPago.tittle_method_1}</h3>
                    <p>{metodoPago.method_1}</p>
                  </div>

                  <div className="easybuy-payment-arrow">
                    <i className="la la-angle-right"></i>
                  </div>
                </div>
              )}

              {metodoPago.status_method_2 && (
                <div className="easybuy-payment-item">
                  <div className="easybuy-payment-icon">
                    <i className="la la-money"></i>
                  </div>

                  <div className="easybuy-payment-content">
                    <h3>{metodoPago.tittle_method_2}</h3>
                    <p>{metodoPago.method_2}</p>
                  </div>

                  <div className="easybuy-payment-arrow">
                    <i className="la la-angle-right"></i>
                  </div>
                </div>
              )}

              {metodoPago.status_method_3 && (
                <div className="easybuy-payment-item">
                  <div className="easybuy-payment-icon">
                    <i className="la la-wallet"></i>
                  </div>

                  <div className="easybuy-payment-content">
                    <h3>{metodoPago.tittle_method_3}</h3>
                    <p>{metodoPago.method_3}</p>
                  </div>

                  <div className="easybuy-payment-arrow">
                    <i className="la la-angle-right"></i>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
